import { create } from "zustand";
import { authClient } from "~/utils/auth-client";
import type { User } from "~/utils/types/user";

type AuthStore = {
	isAuthenticated: boolean;
	user?: User;
	setIsAuthenticated: (isAuthenticated: boolean) => void;
	setUser: (user: User) => void;
	signIn: () => Promise<void>;
	sendMagicLink: (
		email: string,
		name: string,
		callbackURL?: string,
	) => Promise<void>;
	signOut: () => Promise<void>;
};

const useAuthStore = create<AuthStore>((set) => ({
	isAuthenticated: false,
	user: undefined,
	setIsAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
	setUser: (user) => set((state) => ({ user: { ...state.user, ...user } })),
	signIn: async () => {
		await authClient.signIn.social({
			provider: "microsoft",
			callbackURL: "/",
		});
	},
	sendMagicLink: async (email: string, name: string, callbackURL = "/") => {
		await authClient.signIn.magicLink({ email, callbackURL, name });
	},
	signOut: async () => {
		await authClient.signOut();
	},
}));

export default useAuthStore;
